import React, { useEffect, useState } from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

// Actions
import * as UsersActions from 'store/ducks/users/actions';

// Types
import { AppUser } from 'store/ducks/users/types';
import { ApplicationState } from 'store';

// Components
import { SearchAsyncComponent } from 'components/SearchAsyncComponent';

// Helpers
import { useDebouncedSearch } from 'helpers/debounceHook';
import { promiseDispatch } from 'store/utils/promiseAction';
import {
  getCurrentSearchTerm,
  setCurrentSearchTerm,
} from 'helpers/tableFilters';

// Styles
import useStyles from './userFilter.styles';

const UserFilter: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [searchUser, setSearchUser] = useState<any>([]);

  const initialAppUsersList = useSelector(
    (state: ApplicationState) => state.users.appUsersList || null,
  );

  const storegeLimit =
    JSON.parse(window.localStorage.getItem('persist:root') as string)
      ?.localLimit || '10';
  const { localLimit } = JSON.parse(storegeLimit) || 10;

  async function searchUsers(filter: string) {
    if (getCurrentSearchTerm() && filter.trim()) {
      return promiseDispatch(
        UsersActions.filterAppUsersRequest({
          name: `%${filter}%`,
          _page: 1,
          _limit: localLimit,
        }),
      );
    }
    return false;
  }

  const useSearchUsers = () => useDebouncedSearch(searchUsers);

  const [
    autoCompleteText,
    setAutoCompleteText,
    searchResults,
  ] = useSearchUsers();

  useEffect(() => {
    dispatch(
      UsersActions.listAppUsersRequest({
        filtering: true,
      }),
    );
  }, [dispatch]);

  const handleSelectedUser = (item: AppUser) => {
    searchUser.push(item);

    dispatch(
      UsersActions.setSelectedSearchUser({
        selectedSearchUser: searchUser,
      }),
    );
  };

  return (
    <Box>
      <SearchAsyncComponent
        placeholder='Digite o nome do usuário'
        loading={searchResults.loading}
        classes={{
          root: classes.root,
        }}
        inputSize='small'
        onChange={(text: string) => {
          setCurrentSearchTerm(text);
          setAutoCompleteText(text);
          if (!text) {
            dispatch(
              UsersActions.listAppUsersRequest({
                filtering: true,
              }),
            );
          }
        }}
        value={autoCompleteText}
      />

      <Box marginTop={1}>
        <List dense>
          {Array.isArray(initialAppUsersList) &&
            initialAppUsersList.map((item: AppUser) => (
              <ListItem key={item.id} button>
                <ListItemText
                  id={item.id}
                  primary={item.name}
                  onClick={() => handleSelectedUser(item)}
                  classes={{ root: classes.itemText }}
                />
                <ListItemSecondaryAction>
                  <Checkbox
                    edge='end'
                    name={item.name}
                    color='primary'
                    onClick={() => handleSelectedUser(item)}
                    inputProps={{ 'aria-labelledby': item.id }}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            ))}
        </List>
      </Box>
    </Box>
  );
};

export { UserFilter };
export default UserFilter;
